export default __webpack_public_path__ + "static/media/meet-you-mainscreen.6baf22dd.png";